import { INTRODUCTION_LABEL } from '../introduction';
import { ABOUT, CONTACT, ENGLISH, HERO_SUBTITLE, HERO_TITLE,
  HINDI, HOME, HOW_IT_WORKS, LANGUAGE, PARTNER, STATS_CENTRE,
  STATS_CUSTOMER, STATS_FARMERS, STATS_LOCATION, STATS_PARTNERS,
  TEAM, TITLE, NEWS_TITLE, NEWS_SUBTITLE, READ_ARTICLE, STATS_PRODUCTS,
  INPUT, INPUT_DESCRIPTION, INPUT_FEATURE_1, INPUT_FEATURE_2, INPUT_FEATURE_4,
  INPUT_FEATURE_5, INPUT_FEATURE_3, OUTPUT, OUTPUT_DESCRIPTION, OUTPUT_FEATURE_1,
  OUTPUT_FEATURE_2, OUTPUT_FEATURE_3, CROP_ADVISORY, CROP_ADVISORY_DESCRIPTION,
  CROP_ADVISORY_FEATURE_1, CROP_ADVISORY_FEATURE_2, CROP_ADVISORY_FEATURE_3, CROP_ADVISORY_FEATURE_4, CROP_ADVISORY_FEATURE_5,
  FINANCIAL, FINANCIAL_DESCRIPTION, FINANCIAL_FEATURE_1, FINANCIAL_FEATURE_2,
  CONTACT_US, ADDRESS_1, ADDRESS_2, ADDRESS_3, PHONE, EMAIL } from "../../navbar/menu";
import { TEAM_LABEL, TEAM_MEMBER_1_DESCRIPTION, TEAM_MEMBER_1_NAME, TEAM_MEMBER_1_ROLE, TEAM_MEMBER_2_DESCRIPTION, TEAM_MEMBER_2_ROLE, TEAM_MEMBER_3_DESCRIPTION, TEAM_MEMBER_3_NAME, TEAM_MEMBER_3_ROLE, TEAM_MEMBER_2_NAME, TEAM_MEMBER_4_NAME, TEAM_MEMBER_4_ROLE, TEAM_MEMBER_4_DESCRIPTION, TEAM_MEMBER_5_NAME, TEAM_MEMBER_5_ROLE, TEAM_MEMBER_5_DESCRIPTION } from '../team';
import { SERVICES_SUBTITLE, SERVICES_TITLE } from '../services';
import { TESTIMONIAL_DESCRIPTION, TESTIMONIAL_LABEL } from '../testimonial';
import { PARTNER_DESCRIPTION, PARTNER_LABEL } from '../partner';
import { CONTACT_LABEL, QUESTION_FORM_SUBTITLE, QUESTION_FORM_TITLE } from '../contact';

export const enTranslation = {
  [TITLE]: "Freshokartz",
  [LANGUAGE]: "Language",
  [ENGLISH]: "English",
  [HINDI]: "Hindi",

  [HOME]: "HOME",
  [HOW_IT_WORKS]: "HOW IT WORKS",
  [ABOUT]: "ABOUT",
  [PARTNER]: "PARTNER",
  [TEAM]: "TEAM",
  [CONTACT]: "CONTACT",


  [HERO_TITLE]: "Reinventing the Indian agriculture",
  [HERO_SUBTITLE]: "We have dedicated ourselves to reengineer the indian agriculture to support our farmers and boost their productivity with our products, agri specialist and education platforms",

  [STATS_CENTRE]: "Farm Centres",
  [STATS_FARMERS]: "Connected Farmers",
  [STATS_LOCATION]: "District",
  [STATS_CUSTOMER]: "B2B customers",
  [STATS_PARTNERS]: "Partners",
  [STATS_PRODUCTS]: "Different products",

  [NEWS_TITLE]:"News Mentions",
  [NEWS_SUBTITLE]:"Check out our menions in latest news",

  [READ_ARTICLE]: "Read Article",

  [INPUT]: 'Input',
  [INPUT_DESCRIPTION]: 'We offer Seeds, Fertilizers, Pesticides etc. for farmers.',
  [INPUT_FEATURE_1]: '💸 At affordable rates.',
  [INPUT_FEATURE_2]: '🚪 We deliver at your doorstep.',
  [INPUT_FEATURE_3]: '📞 You can place orders over a phone call. ',
  [INPUT_FEATURE_4]: '💯 We offer the best quality products.',
  [INPUT_FEATURE_5]: '🛒 We have more than 10000 different types of products.',

  [OUTPUT]: 'Output',
  [OUTPUT_DESCRIPTION]: 'Farmers can easily sell their Yield to Freshokartz.',
  [OUTPUT_FEATURE_1]: '🚚 Direct Connectivity with the market.',
  [OUTPUT_FEATURE_2]: '⚖️ Transperant weighing and rate at one place.',
  [OUTPUT_FEATURE_3]: '💸 Immediate payment of the agri produce.',

  [CROP_ADVISORY]: 'Crop Advisory',
  [CROP_ADVISORY_DESCRIPTION]: 'Our excellent agri experts are always there for you.',
  [CROP_ADVISORY_FEATURE_1]: '🔬 Soil Testing.',
  [CROP_ADVISORY_FEATURE_2]: '👨🏼 Free field and crop inspection by agri experts.',
  [CROP_ADVISORY_FEATURE_3]: '❗️ Consultation, Prevention & Cure of Crop Diseases.',
  [CROP_ADVISORY_FEATURE_4]: '📕 Free Consultation & Guidance from sowing to reaping by our expert agri advisors.',
  [CROP_ADVISORY_FEATURE_5]: '📣 24X7 Helpline support.',

  [FINANCIAL]: 'Financial',
  [FINANCIAL_DESCRIPTION]: 'Loaning/ Financing',
  [FINANCIAL_FEATURE_1]: '💸 Credit Facility During Season.',
  [FINANCIAL_FEATURE_2]: '🚜 Agricultural Equipment financing.',

  [CONTACT_US]: "Contact Us",

  [ADDRESS_1]: "716,  7th Floor, Elements mall",
  [ADDRESS_2]: "DCM, Ajmer Road, Jaipur",
  [ADDRESS_3]: "Rajasthan 302021",
  [PHONE]: "Phone:",
  [EMAIL]: "Email:",

  [INTRODUCTION_LABEL]: "Understand how Freshokartz works.",

  [TEAM_LABEL]: "Our Team",
  [TEAM_MEMBER_1_NAME]: "Rajendra Lora",
  [TEAM_MEMBER_1_ROLE]: "Co-Founder and CEO",
  [TEAM_MEMBER_1_DESCRIPTION]: "Ex. Software Engineer, Suvidhaa.com | B. Tech. IIIT Jabalpur",

  [TEAM_MEMBER_2_NAME]: "Chandrakanta Sahu",
  [TEAM_MEMBER_2_ROLE]: "Co-Founder and COO",
  [TEAM_MEMBER_2_DESCRIPTION]: "Head of Operations Netprologic",

  [TEAM_MEMBER_3_NAME]: "Laxman Sharma",
  [TEAM_MEMBER_3_ROLE]: "Chief Technology Officer",
  [TEAM_MEMBER_3_DESCRIPTION]: "Ex. Backend Developer, Booking.com | Ex. Full Stack Developer Credit Suisse",

  [TEAM_MEMBER_4_NAME]: "Saksham Sharma",
  [TEAM_MEMBER_4_ROLE]: "Executive Vice President",
  [TEAM_MEMBER_4_DESCRIPTION]: "Founder of 2 successful startups",

  [TEAM_MEMBER_5_NAME]: "Ravi Dhaka",
  [TEAM_MEMBER_5_ROLE]: "AVP Business Development & Operations",
  [TEAM_MEMBER_5_DESCRIPTION]: "Ex. Relationship Manager, HDFC",

  [SERVICES_TITLE]: "Our Services",
  [SERVICES_SUBTITLE]: "Helping farmers throughtout their Journey",

  [TESTIMONIAL_LABEL]: "Testimonials",
  [TESTIMONIAL_DESCRIPTION]: "We love to hear our customers. See what other farmers say about Freshokartz.",

  [PARTNER_LABEL]: "Our Partners",
  [PARTNER_DESCRIPTION]: "We work with the best in the industry.",

  [CONTACT_LABEL]: "Contact Us",
  [QUESTION_FORM_TITLE]: "Have a Question?",
  [QUESTION_FORM_SUBTITLE]: "Let us know. Our Team will reach out to you."

};
